import React, { useState, useEffect, Fragment } from 'react';
import { apiService } from '../../components/Config/api.service';
import { CompanyInfo } from '../../components/Setup/CompanyInfo';
import { EmployeeCountStep } from '../../components/Setup/EmployeeCount';
import Documents from '../Employee/Profil/Documents';
import { AdminInfo } from '../../components/Setup/AdminInfo';
import { CompanyDocuments } from '../../components/Setup/CompanyDocuments';

const MultiStepRegistration = () => {
    const [currentStep, setCurrentStep] = useState(1);
    const [formData, setFormData] = useState({
        companyName: '',
        legalForm: '',
        companyId: '',
        companyAddress: '',
        city: '',
        sector: '',
        hourlyRate: '',
        termsAccepted: false,

        employeeCount: '10-30',
        payrollManagement: 'no-payslip',

        companyLogo: null,
        administrativeDoc: null,

        lastName: '',
        firstName: '',
        email: '',
        phone: '',
        password: '',
        confirmPassword: '',
        position: ''
    });
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const totalSteps = 4;

    const handleInputChange = (field, value) => {
        setFormData({
            ...formData,
            [field]: value
        });
    };

    const nextStep = () => {

        if (currentStep < totalSteps) {
            setCurrentStep(currentStep + 1);
            window.scrollTo(0, 0);
        } else {
            handleSubmit();
        }

        console.log('formData ', formData)
    };

    const previousStep = () => {
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
            window.scrollTo(0, 0);
        }
    };

    const handleSubmit = async () => {
        console.log('formData ', formData)
        setErrorMessage('');
        setSuccessMessage('');
        setIsLoading(true);
        try {
            const apiData = {
                company_name: formData.companyName,
                company_address: formData.companyAddress,
                country: formData.city,
                username: formData.firstName + ' ' + formData.lastName,
                email: formData.email,
                password: formData.password
            };

            const response = await apiService.register(apiData);
            setSuccessMessage('Utilisateur et société créés avec succès !');
            setTimeout(() => {
                setIsLoading(false);
            }, 2000);
        } catch (error) {
            console.error('Erreur lors de l\'inscription:', error);
            setErrorMessage('Erreur lors de la création. Veuillez réessayer.');
            setIsLoading(false);
        } finally {
            setIsLoading(false);
        }
    };

    const renderStep = () => {
        switch (currentStep) {
            case 1:
                return (
                    <CompanyInfo
                        formData={formData}
                        onChange={handleInputChange}
                    />
                );
            case 2:
                return (
                    <EmployeeCountStep
                        formData={formData}
                        onChange={handleInputChange}
                    />
                );
            case 3:
                return (
                    <CompanyDocuments
                        formData={formData}
                        onChange={handleInputChange}
                    />
                );
            case 4:
                return (
                    <AdminInfo
                        formData={formData}
                        onChange={handleInputChange}
                        isLoading={isLoading}
                    />
                );
            default:
                return null;
        }
    };

    const StepLabel = ({ number, title, isActive, isCompleted }) => (
        <div className="flex flex-col items-center">
            <div className={`w-3 h-3 rounded-full flex items-center justify-center transition-all duration-300
                ${isActive ? 'bg-[--color-primary] text-white scale-110' :
                    isCompleted ? 'bg-green-500 text-white' : 'bg-gray-200 text-gray-600'}`}>

            </div>

        </div>
    );

    const stepTitles = ['Infos entreprise', 'Employés', 'Documents', 'Admin'];

    return (
        <div className="min-h-screen flex flex-col bg-[--bg-color]">

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 px-8 py-6 border-b border-gray-200 content-center">
                <div className='text-center text-4xl text-[--color-primary] font-extrabold'> YROS </div>
                <div className="flex justify-between items-center">
                    {[...Array(totalSteps)].map((_, index) => (
                        <React.Fragment key={index}>
                            <StepLabel
                                number={index + 1}
                                title={stepTitles[index]}
                                isActive={index + 1 === currentStep}
                                isCompleted={index + 1 < currentStep}
                            />
                            {index < totalSteps - 1 && (
                                <div className="relative flex-1 h-1 mx-2">
                                    <div className="absolute w-full h-full bg-gray-200 rounded"></div>
                                    <div
                                        className="absolute h-full bg-[--color-primary] rounded transition-all duration-500"
                                        style={{ width: index + 1 < currentStep ? '100%' : '0%' }}
                                    ></div>
                                </div>
                            )}
                        </React.Fragment>
                    ))}
                </div>
                <div className='text-center text-xl'>
                    <span className='text-gray-500'> Vous avez une question ? </span>
                    <span className='text-[--color-orange]'> Contactez-nous </span>
                </div>
            </div>
            <div className="container mx-auto px-4 py-12 flex-1">
                <div className="max-w-4xl mx-auto bg-white rounded-xl overflow-hidden">


                    <div className="p-8">
                        {/* Messages d'erreur/succès */}
                        {errorMessage && (
                            <div className="mb-6 p-4 bg-red-50 border-l-4 border-red-500 text-red-700 rounded animate-fadeIn">
                                <div className="flex items-center">
                                    <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                                    </svg>
                                    {errorMessage}
                                </div>
                            </div>
                        )}

                        {isLoading ? (
                            <div className="flex justify-center py-8">
                                <div className="relative w-16 h-16">
                                    <div className="absolute top-0 w-full h-full border-4 border-gray-200 rounded-full"></div>
                                    <div className="absolute top-0 w-full h-full border-4 border-blue-600 rounded-full border-t-transparent animate-spin"></div>
                                </div>
                            </div>
                        ) : (successMessage ?
                            <div className="mt-8 mb-12 text-center">
                                <div className="flex items-center justify-center mb-6">
                                    <div className="bg-green-100 rounded-full p-3">
                                        <svg className="w-8 h-8 text-green-500" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                        </svg>
                                    </div>
                                </div>

                                <h2 className="text-2xl font-bold text-gray-800 mb-2">Votre compte a été configuré avec succès !</h2>
                                <p className="text-gray-600 mb-8 max-w-md mx-auto">Toutes les informations ont été enregistrées. Vous pouvez maintenant vous connecter à votre espace YROS.</p>

                                <div className="flex justify-center">
                                    <button
                                        type="button"
                                        className="bg-[--color-primary] hover:bg-[--color-orange] text-white px-8 py-3 rounded-lg font-medium transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-1 active:translate-y-0 flex items-center"
                                        onClick={() => window.location.href = '/'}
                                    >
                                        <span>Se connecter</span>
                                        <svg className="w-5 h-5 ml-2" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                                        </svg>
                                    </button>
                                </div>
                            </div> :
                            <Fragment>
                                {renderStep()}
                            </Fragment>)
                        }

                        {!successMessage && <div className="flex justify-between">
                            <button
                                type="button"
                                className="border btn-outline text-[--color-primary] px-8 py-2 rounded-lg"
                                onClick={previousStep}
                            >
                                Précédent
                            </button>
                            <button
                                type="button"
                                className="bg-[--color-primary] text-white px-8 py-2 rounded-lg"
                                onClick={nextStep}
                            >
                                Suivant
                            </button>
                        </div>}
                    </div>
                </div>
            </div>

            <footer className="py-12 border-t border-gray-200 mt-8">
                <div className="container mx-auto px-4">
                    <div className="text-center mb-8">
                        <h3 className="text-2xl font-bold mb-3 text-gray-800">Votre gestion de la paie simple, fiable et automatisée</h3>
                        <p className="text-gray-600 max-w-2xl mx-auto">Simplifiez vos démarches administratives et gagnez du temps avec notre logiciel en ligne de paie et RH.</p>
                    </div>

                    <div className="flex flex-wrap justify-center items-center gap-8 grayscale opacity-70">
                        <div className="transform hover:scale-105 hover:opacity-100 transition-all">
                            <img src="/api/placeholder/120/50" alt="Yassir" className="h-12" />
                        </div>
                        <div className="transform hover:scale-105 hover:opacity-100 transition-all">
                            <img src="/api/placeholder/120/50" alt="YANGO" className="h-12" />
                        </div>
                        <div className="transform hover:scale-105 hover:opacity-100 transition-all">
                            <img src="/api/placeholder/120/50" alt="Tersea" className="h-12" />
                        </div>
                        <div className="transform hover:scale-105 hover:opacity-100 transition-all">
                            <img src="/api/placeholder/120/50" alt="BIC" className="h-12" />
                        </div>
                        <div className="transform hover:scale-105 hover:opacity-100 transition-all">
                            <img src="/api/placeholder/120/50" alt="SOMMES" className="h-12" />
                        </div>
                        <div className="transform hover:scale-105 hover:opacity-100 transition-all">
                            <img src="/api/placeholder/120/50" alt="Nestlé" className="h-12" />
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default MultiStepRegistration;